module.exports = __webpack_public_path__ + "img/rubin_benefit_13_animal.d144b235.svg";